import styled from 'styled-components';

export const DebtDetailBreadcrumb = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	font-size: 14px;
	color: #6B7280;
    padding: 16px 0px;
`;

export const BreadcrumbItem = styled.span<{ active?: boolean }>`
	color: ${props => props.active ? '#9CA3AF' : '#374151'};
	cursor: ${props => props.active ? 'default' : 'pointer'};
	text-decoration: none;
	
	&:hover {
		color: ${props => props.active ? '#9CA3AF' : '#1F2937'};
	}
	
	a {
		color: inherit;
		text-decoration: none;
		
		&:hover {
			color: inherit;
		}
	}
`;

export const BreadcrumbSeparator = styled.img`
	width: 12px;
	height: 12px;
	margin: 0 4px;
`;

export const DebtDetailContainer = styled.div`
	width: 1200px;
	margin: 0 auto;
	max-width: 1440px;
	padding: 24px 0;
	background-color: #F3F4F6;
`;

export const DebtDetailMainTitle = styled.h1`
	font-size: 24px;
	font-weight: 700;
	color: #111827;
	margin: 0 0 24px 0;
`;

export const DebtDetailHeader = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	margin-bottom: 24px;
    background: #EFF6FF;
    padding: 20px 15px;
`;

export const DebtDetailTitle = styled.h1`
	font-size: 24px;
	font-weight: 700;
	color: #111827;
	margin: 0 0 8px 0;
`;

export const DebtDetailSubtitle = styled.h2`
	font-size: 16px;
	font-weight: 400;
	color: #374151;
	margin: 0;
`;

export const DebtDetailSentButton = styled.button`
	background-color: #10B981;
	color: white;
	border: none;
	border-radius: 6px;
	padding: 12px 24px;
	font-size: 14px;
	font-weight: 500;
	cursor: pointer;
	transition: all 0.2s ease;
	
	&:hover {
		background-color: #059669;
	}
`;

export const DebtDetailSummaryCards = styled.div`
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	gap: 16px;
	margin-bottom: 32px;
`;

export const DebtDetailCard = styled.div`
	background-color: #FFFFFF;
	border: 1px solid #E5E7EB;
	border-radius: 8px;
	padding: 20px;
	display: flex;
	align-items: center;
	gap: 16px;
	transition: all 0.3s ease;
	cursor: pointer;
	
	&:hover {
		background-color: #005E9E;
		
		* {
			color: #ffffff !important;
		}
	}
`;

export const DebtDetailCardIcon = styled.div<{ color: string }>`
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
`;

export const DebtDetailCardContent = styled.div`
	flex: 1;
`;

export const DebtDetailCardText = styled.div`
	font-size: 14px;
	color: #6B7280;
	margin-bottom: 8px;
`;

export const DebtDetailCardValue = styled.div<{ color: string }>`
	font-size: 18px;
	font-weight: 600;
	color: ${props => props.color};
`;

export const DebtDetailSection = styled.div`
	background-color: #FFFFFF;
	border-radius: 8px;
	margin-bottom: 24px;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

export const DebtDetailSectionHeader = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
    padding: 16px 24px;
`;

export const DebtDetailSectionTitle = styled.h3`
	font-size: 18px;
	font-weight: 600;
	color: #111827;
	margin: 0;
`;

export const DebtDetailSectionActions = styled.div`
	display: flex;
	align-items: center;
`;

export const DebtDetailFilterRow = styled.div`
	display: flex;
	gap: 12px;
	align-items: center;
`;

export const DebtDetailSearchInput = styled.input`
	flex: 1;
	min-width: 300px;
	padding: 12px 16px;
	border: 1px solid #D1D5DB;
	border-radius: 6px;
	font-size: 14px;
	background-image: url('./static/img/search.png');
	background-repeat: no-repeat;
	background-position: 12px center;
	background-size: 16px 16px;
	
	&:focus {
		outline: none;
	}
`;

export const DebtDetailSelect = styled.select`
	padding: 12px 16px;
	border: 1px solid #D1D5DB;
	border-radius: 6px;
	font-size: 14px;
	background-color: white;
	appearance: none;
	background-image: url('./static/img/dropdown.png');
	background-repeat: no-repeat;
	background-position: right 12px center;
	background-size: 16px 16px;
	cursor: pointer;
	
	&:focus {
		outline: none;
		border-color: #D1D5DB;
	}
`;

export const DebtDetailAddButton = styled.button`
	background-color: #005E9E;
	color: white;
	border: none;
	border-radius: 6px;
	padding: 12px 20px;
	font-size: 14px;
	font-weight: 500;
	cursor: pointer;
	transition: all 0.2s ease;
	display: flex;
	align-items: center;
	gap: 8px;
	
	&:hover {
		background-color: #005E9E;
	}
`;

export const DebtDetailTable = styled.div`
	width: 100%;
	border-radius: 8px;
	overflow: hidden;
`;

export const DebtDetailTableHeader = styled.div<{ isBookingTable?: boolean }>`
	display: grid;
	grid-template-columns: ${props => props.isBookingTable ? '1fr 1.5fr 1fr 1fr 0.5fr 0.8fr 1fr 1.3fr 1fr' : '1fr 1fr 1.5fr 1fr 1.5fr 2.5fr'};
	gap: 16px;
	padding: 16px;
	background-color: #F9FAFB;
	border-bottom: 1px solid #E5E7EB;
	font-size: 12px;
	font-weight: 600;
	color: #6B7280;
	align-items: center;
	align-content: center;
`;

export const DebtDetailTableRow = styled.div<{ isBookingTable?: boolean }>`
	display: grid;
	grid-template-columns: ${props => props.isBookingTable ? '1fr 1.5fr 1fr 1fr 0.5fr 0.8fr 1fr 1.3fr 1fr' : '1fr 1fr 1.5fr 1fr 1.5fr 2.5fr'};
	gap: 16px;
	padding: 16px;
	border-bottom: 1px solid #E5E7EB;
	align-items: center;
	
	&:hover {
		background-color: #FFF7ED;
	}
`;

export const DebtDetailTableCell = styled.div<{ alignRight?: boolean }>`
	display: flex;
	align-items: center;
	font-size: 14px;
	color: #374151;
	min-width: 0;
	overflow: hidden;
	justify-content: ${props => props.alignRight ? 'flex-end' : 'flex-start'};
`;

export const DebtDetailStatusBadge = styled.span<{ backgroundColor: string; textColor: string }>`
	background-color: ${props => props.backgroundColor};
	color: ${props => props.textColor};
	padding: 6px 12px;
	border-radius: 16px;
	font-size: 12px;
	font-weight: 500;
	margin-right: 8px;
	display: inline-flex;
	align-items: center;
	gap: 6px;
	
	&::before {
		content: '';
		width: 6px;
		height: 6px;
		border-radius: 50%;
		background-color: ${props => props.textColor};
		flex-shrink: 0;
	}
`;

export const DebtDetailActionButton = styled.button<{ backgroundColor: string; textColor: string }>`
	background-color: ${props => props.backgroundColor};
	color: ${props => props.textColor};
	border: none;
    border-radius: 4px;
    padding: 1px 20px;
    font-size: 12px;
    cursor: pointer;
    transition: 0.2s;
`;

export const DebtDetailDetailsLink = styled.div`
	color: #005E9E;
	text-decoration: none;
	font-size: 14px;
	font-weight: 500;
	display: flex;
	align-items: center;
	gap: 4px;
	cursor: pointer;
	
	&:hover {
		text-decoration: none;
		color: #004A7C;
	}
`;

export const DebtDetailEmptyState = styled.div`
	grid-column: 1 / -1;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 60px 20px;
	text-align: center;
`;

export const DebtDetailEmptyIcon = styled.div`
	width: 80px;
	height: 80px;
	border-radius: 50%;
	background-color: #F3F4F6;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-bottom: 16px;
	
	img {
		width: 40px;
		height: 40px;
		opacity: 0.5;
	}
`;

export const DebtDetailEmptyText = styled.div`
	font-size: 16px;
	font-weight: 500;
	color: #6B7280;
	margin-bottom: 8px;
`;

export const DebtDetailEmptySubtext = styled.div`
	font-size: 14px;
	color: #9CA3AF;
`;
